import { ProjectInterface } from "@/types/project";
import { get } from "@/utils/taskApiClient.utils";

export const listProject = () => {
  return get<ProjectInterface[]>("projects");
};